import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import {ActivatedRoute,Router, Routes, RouterModule} from '@angular/router'
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { HeaderComponent } from './layout/header/header.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { FooterComponent } from './layout/footer/footer.component';
import { LoginComponent } from './user/login/login.component';
import { RegisterComponent } from './user/register/register.component';
import { AccountComponent } from './user/account/account.component';
import { EditAccountComponent } from './user/edit-account/edit-account.component';
import { AllchannelsComponent } from './pages/allchannels/allchannels.component';
import { AllCategoriesComponent } from './pages/all-categories/all-categories.component';
import { SubscriptionsComponent } from './pages/subscriptions/subscriptions.component';
import { WatchhistoryComponent } from './pages/watchhistory/watchhistory.component';
import { SingleChannelComponent } from './pages/singlechannel/singlechannel.component';
import { FreeContentComponent } from './pages/snippets/free-content/free-content.component';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { AuthService } from './auth.service';
import { AuthGuardService } from './auth-guard.service';
import { JwtModule } from '@auth0/angular-jwt';
import { HttpHeaders } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './token-interceptor';
import { HttpParams } from '@angular/common/http';
import { PathLocationStrategy, LocationStrategy } from '@angular/common';
import { CategoriesAllComponent } from './pages/snippets/categories-all/categories-all.component';
import { ChannelsAllComponent } from './pages/snippets/channels-all/channels-all.component';
import { PopularContentComponent } from './pages/snippets/popular-content/popular-content.component';
import { VideoComponent } from './pages/video/video.component';
import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SinglecategoryComponent } from './pages/single-category/single-category.component';
import { OwlModule } from 'ngx-owl-carousel';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { SubscribeComponent } from './user/subscribe/subscribe.component';
import { PlaylistComponent } from './pages/playlist/playlist.component';
import { LivestreamComponent } from './pages/livestream/livestream.component';
import { ForgotPasswordComponent } from './user/forgot-password/forgot-password.component';
import { SearchComponent } from './pages/search/search.component';
import { LogoutComponent } from './user/logout/logout.component';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { RecentViewComponent } from './pages/snippets/recent-view/recent-view.component';
import { SubscribeOtpComponent } from './user/subscribe-otp/subscribe-otp.component';
import { MyListComponent } from './pages/my-list/my-list.component';
import { WatchLaterComponent } from './pages/watch-later/watch-later.component';
import { NgxNewstickerAlbeModule } from 'ngx-newsticker-albe';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { FormsModule }        from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { InternationalPhoneNumberModule } from 'ngx-international-phone-number';
import { UnsubscribeComponent } from './user/unsubscribe/unsubscribe.component';
import {SlideshowModule} from 'ng-simple-slideshow';
import { LaterSnippetComponent } from './pages/snippets/later-snippet/later-snippet.component';
import { FavSnippetComponent } from './pages/snippets/fav-snippet/fav-snippet.component';
import { NewPasswordComponent } from './user/new-password/new-password.component';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { SubAndRegComponent } from './user/sub-and-reg/sub-and-reg.component';
import { WrapMeComponent } from './wrap-me/wrap-me.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { DemoComponent } from './pages/demo/demo.component';
import { NguCarouselModule } from '@ngu/carousel';
import { WoohooLandingComponent } from './pages/woohoo-landing/woohoo-landing.component';
import { AllContentComponent } from './pages/snippets/all-content/all-content.component';
import { CallToActionComponent } from './pages/snippets/call-to-action/call-to-action.component';
import { NgMarqueeModule } from "ng-marquee-improved";
import { WinnersComponent } from './pages/winners/winners.component';
import { SubscribeChoiceComponent } from './user/subscribe-choice/subscribe-choice.component';
import { VideoPlayerComponent } from './testing/video-player/video-player.component';
import { VgCoreModule } from 'videogular2/compiled/core';
import { VgControlsModule } from 'videogular2/compiled/controls';
import { VgOverlayPlayModule } from 'videogular2/compiled/overlay-play';
import { VgBufferingModule } from 'videogular2/compiled/buffering';
import { PdfViewerModule } from 'ng2-pdf-viewer';
const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};
export function tokenGetter() {
    return localStorage.getItem('token');
}
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
    LoginComponent,
    RegisterComponent,
    AccountComponent,
    EditAccountComponent,
    AllchannelsComponent,
    AllCategoriesComponent,
    SubscriptionsComponent,
    WatchhistoryComponent,
    SingleChannelComponent,
    FreeContentComponent,
    CategoriesAllComponent,
    ChannelsAllComponent,
    PopularContentComponent,
    VideoComponent,
    SinglecategoryComponent,
    SubscribeComponent,
    PlaylistComponent,
    LivestreamComponent,
    ForgotPasswordComponent,
    SearchComponent,
    LogoutComponent,
    RecentViewComponent,
    SubscribeOtpComponent,
    MyListComponent,
    WatchLaterComponent,
    UnsubscribeComponent,
    LaterSnippetComponent,
    FavSnippetComponent,
    NewPasswordComponent,
    SubAndRegComponent,
    WrapMeComponent,
    TermsAndConditionsComponent,
    DemoComponent,
    WoohooLandingComponent,
    AllContentComponent,
    CallToActionComponent,
    WinnersComponent,
    SubscribeChoiceComponent,
    VideoPlayerComponent
  ],
  imports: [
    BrowserModule,
    PdfViewerModule,
    FormsModule,
    NgMarqueeModule,
    NgxSmartModalModule.forRoot(),
    InternationalPhoneNumberModule,
    AppRoutingModule,
    SlideshowModule,
    NgxSpinnerModule,
    OwlModule,
    LoadingBarRouterModule,
    [NguCarouselModule],
    SwiperModule,
    HttpModule,
    HttpClientModule,
    VgCoreModule,
    VgOverlayPlayModule,
    VgBufferingModule,
       VgControlsModule,
    [ NgxNewstickerAlbeModule ],
    JwtModule.forRoot({
        config: {
            tokenGetter: tokenGetter,
            whitelistedDomains: ['vidapp.jamesshier.com/'],
            blacklistedRoutes: ['example.com/examplebadroute/']
          }
      })
  ],
  providers:
  [
    {
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true
  },
  {
    provide: SWIPER_CONFIG,
    useValue: DEFAULT_SWIPER_CONFIG
  },
  {provide: LocationStrategy, useClass: PathLocationStrategy}
],
  bootstrap: [AppComponent]
})
export class AppModule { }
